import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-service/page-service-view.tsx");
